module.exports = __webpack_public_path__ + "img/growthAbility4.e47bb93f.png";